import axios from 'axios';


// headers: the launch's correlation headers (X-Operation-ID), sent with every poll.
export const poll_task = async (task_id, headers = {}) => {

  const start = new Date().getTime();
  let completed = false;

  while(!completed) {

    if((new Date().getTime() - start) > 60000) {
      throw Object.assign(new Error('OS user creation task took longer than one minute'), {code: 'task_timeout'})
    }

    const data = (await axios({
      url: `/api/tasks/${task_id}`,
      headers,
    })).data;

    if(data.failed) {
      throw Object.assign(new Error('OS user creation task failed'), {code: 'task_failed'})
    }

    completed = (data.status === 'done');

    await new Promise(resolve => setTimeout(resolve, 5000));

  }

};
